import { render, staticRenderFns } from "./SessionExpiredModal.vue?vue&type=template&id=44711a9b"
import script from "./SessionExpiredModal.vue?vue&type=script&lang=ts"
export * from "./SessionExpiredModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports